import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const StorageLocation = () => {
  return(
    <SettingsMetaData propertyName={"AssertStorageLocation"} viewPropertyName={"Asset Storage Location"} />
  )
};

export default StorageLocation;
